import React from 'react';
import './Contact.css';

export default function Contact() {
  return (
    <section className="section contact anchor" id="contact">
      <div className="container">
        <header className="contact__header">
          <h2 className="contact__title">Ready to Get Started?</h2>
          <p className="contact__subtitle">
            If you need a project manager or IT specialist who delivers and keeps systems stable,
            let’s talk.
          </p>
        </header>

        <div className="contact__cards" aria-label="Contact methods">
          <a className="contact__card" href="tel:+233548239576">
            <div className="contact__label">Phone</div>
            <div className="contact__value">054 823 9576</div>
          </a>

          <a
            className="contact__card"
            href="https://wa.me/233548239576?text=Hi%20Emmanuel%2C%20I%20found%20your%20website%20and%20I%27d%20like%20to%20discuss%20working%20together%20on%20a%20project.%20Could%20we%20schedule%20a%20consultation%3F"
            target="_blank"
            rel="noreferrer"
          >
            <div className="contact__label">WhatsApp</div>
            <div className="contact__value">Message on WhatsApp</div>
          </a>

          <a
            className="contact__card"
            href="mailto:me@emmanuelobengconsulting.com?subject=Booking%20a%20Consultation&body=Hi%20Emmanuel%2C%0A%0AI%20came%20across%20your%20website%20and%20would%20like%20to%20book%20a%20consultation%20to%20discuss%20my%20project%20needs.%0A%0A%5BPlease%20describe%20your%20project%20or%20inquiry%20here%5D%0A%0ABest%20regards"
          >
            <div className="contact__label">Email</div>
            <div className="contact__value">me@emmanuelobengconsulting.com</div>
          </a>

          <a
            className="contact__card"
            href="https://www.linkedin.com/in/emmanuel-obeng-pmp%C2%AE-psm1-itil-215975143"
            target="_blank"
            rel="noreferrer"
          >
            <div className="contact__label">LinkedIn</div>
            <div className="contact__value">View profile</div>
          </a>

          <a
            className="contact__card"
            href="https://www.upwork.com/freelancers/~01df6a96e8f5bbc220"
            target="_blank"
            rel="noreferrer"
          >
            <div className="contact__label">Upwork</div>
            <div className="contact__value">Hire on Upwork</div>
          </a>
        </div>

        <div className="contact__ctaRow">
          <a className="contact__primaryCta" href="#work-with-me">
            Book a Consultation
          </a>
          <a className="contact__secondaryCta" href="#services">
            Explore Services
          </a>
        </div>
      </div>
    </section>
  );
}
